export const TAG = `
query tag(
    $tenant_id: Int!
    $id: number! 
){
    tag(
        tenant_id: $tenant_id
        id: $id
    )
{
    __typename
    ... on Tag{
        id
        name
        entities
        hex_color
    }
    ... on ResultError{
        status_code
        message
        message_translation_key
    }
}
}
`;

export const TAGS = `
query tags(
    $tenant_id: Int!
    $filter:  FilterTagInput,
    $orderBy:  TagOrderInput,
    $skip: Int,
    $take: Int,
    $searchText: String,
){
    tags(
        tenant_id: $tenant_id
        filter: $filter
        orderBy: $orderBy
        skip: $skip
        take: $take
        searchText: $searchText
    )
{
    __typename
    ... on Tag{
        id
        name
        entities
        hex_color
    }
    ... on ResultError{
        status_code
        message
        message_translation_key
    }
}
}
`;
